import React, { useState } from "react";
import { ColDef, ColGroupDef } from "ag-grid-community";
import { IconWithTooltip } from "@/components/Icons/IconFactory";
import Dialog from "@/components/Dialog/Dialog";
import { ActionCellRenderer } from "./ActionCellRenderer";

export const thresholdColumnDefs: (ColDef | ColGroupDef)[] = [
  {
    headerName: "",
    children: [
      {
        headerName: "",
        field: "isDefaultValue",
        width: 53,
        minWidth: 53,
        maxWidth: 53,
        resizable: false,
        suppressSizeToFit: true,
        cellRenderer: (params: any) => (params.value ? "✱" : ""),
        cellStyle: {
          color: "rgb(0, 93, 164)",
          fontWeight: "bold",
          fontSize: "15px",
          textAlign: "left",
          borderRight: "1px solid #E5E7EB",
        },
      },
    ],
  },
  {
    headerName: "",
    children: [
      {
        headerName: "Commodity",
        field: "commodity",
        width: 180,
        cellStyle: {
          borderRight: "1px solid #E5E7EB",
          textAlign: "left",
          paddingLeft: "8px",
        },
      },
    ],
  },
  {
    headerName: "High Risk",
    children: [
      {
        headerName: "Min",
        field: "highRiskMin",
        width: 90,
        headerClass: "header-red-pill",
      },
      {
        headerName: "Max",
        field: "highRiskMax",
        width: 90,
        headerClass: "header-red-pill",
      },
    ],
  },
  {
    headerName: "Medium Risk",
    children: [
      {
        headerName: "Min",
        field: "mediumRiskMin",
        width: 90,
        headerClass: "header-yellow-pill",
      },
      {
        headerName: "Max",
        field: "mediumRiskMax",
        width: 90,
        headerClass: "header-yellow-pill",
      },
    ],
  },
  {
    headerName: "Low Risk",
    children: [
      {
        headerName: "Min",
        field: "lowRiskMin",
        width: 90,
        headerClass: "header-green-pill",
      },
      {
        headerName: "Max",
        field: "lowRiskMax",
        width: 90,
        headerClass: "header-green-pill",
      },
    ],
  },
  {
    headerName: "",
    children: [
      {
        headerName: "Action",
        field: "action",
        width: 80,
        cellStyle: {
          borderRight: "1px solid #E5E7EB",
          display: "flex",
          alignItems: "center",
          padding: "0 20px",
        },
        cellRenderer: ActionCellRenderer,
      },
    ],
  },
];
